export function Parents(el, parentSelector) {
  // console.log(parentSelector)
  if(el != null){  
    if (parentSelector === undefined) {
        parentSelector = document;
    }
    var parents = [];
    var p = el.parentNode;
    var foundMatch = false;
    while (p !== parentSelector && p !== null) {
        var o = p;
        parents.push(o);
        p = o.parentNode;
        if(p === parentSelector)
        foundMatch = true; break;
    }
    // console.log(p === parentSelector)
    // parents.push(parentSelector);
    if(foundMatch)
      return parentSelector;
    else 
      return false;
  }
  return false;
}


